import { useSelector } from 'react-redux';
import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';

const GET_RELATED = gql`
  query related($id: String!, $community: String!) {
    relatedUsers(id: $id, community: $community) {
      handle
      _id
      name
      image
      relevance {
        reputation
      }
    }
  }
`;

export const useRelatedUsers = (id: string) => {
  const community = useSelector((state: any) => state?.auth?.community);
  return useQuery(GET_RELATED, {
    variables: {
      id,
      community,
    },
  });
};
